import axios from 'axios'
import { getCSRF } from 'src/lib/cookie.js'

export default function(method, url, data, params, response_type = 'json', extraHeaders = {}) {
    let csrf_token = getCSRF()

    let promise = axios({
        method: method,
        url: url,
        data: data,
        params: params,
        responseType: response_type,
        headers: {'X-CSRFToken': csrf_token, ...extraHeaders}
    })
    return promise
}
